export const getSecondWord = (str: string): string => {
  const categoryWords = str.split(' ');
  return categoryWords.length > 1 ? categoryWords[1] : '';
};
